import { EyeOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Button, Tag } from "antd";
import { AssetListListingComponent } from "../../components/sub_components/assets/AssetListListingComponent";

const columnCallback = (handleClickViewPostHTML) => {
  return [
    {
      title: "Listings",
      key: "actions",
      render: (row) => (
        <Button
          type="primary"
          size="small"
          icon={<EyeOutlined />}
          onClick={() =>
            handleClickViewPostHTML(
              <AssetListListingComponent
                listings={row.listings}
                asset_listing_id={row.asset_listing_id}
              />
            )
          }
        >
          View Listing
        </Button>
      ),
    },
    {
      title: "Asset Listing Price Min",
      dataIndex: "asset_listing_price_min",
      key: "asset_listing_price_min",
    },
    {
      title: "Asset Listing Price Max",
      dataIndex: "asset_listing_price_max",
      key: "asset_listing_price_max",
    },
    {
      title: "Listing Method",
      dataIndex: "listing_method",
      key: "listing_method",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) =>
        status ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        ),
    },
    {
      title: "Date Creation",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Last Modified Date",
      dataIndex: "updated_at",
      key: "updated_at",
    },
  ];
};

export default function useGetAssetContentsColumns(handleClickViewPostHTML) {
  let columns = columnCallback(handleClickViewPostHTML);
  const [tableColumns, setColumns] = useState(columns);

  useEffect(() => {
    setColumns(columns);
  }, []);

  return tableColumns;
}
